import * as actionTypes from "../ActionTypes";

// ✅ Fetch Resources
export const fetchResourcesRequest = (payload, callback) => ({
  type: actionTypes.FETCH_RESOURCES_REQUEST,
  payload,
  callback,
});

export const fetchResourcesSuccess = (data) => ({
  type: actionTypes.FETCH_RESOURCES_SUCCESS,
  payload: data,
});

export const fetchResourcesFailure = (error) => ({
  type: actionTypes.FETCH_RESOURCES_FAILURE,
  payload: error,
});

// ✅ Save Resource
export const saveResourceRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_RESOURCE_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});


export const saveResourceSuccess = (data) => ({
  type: actionTypes.SAVE_RESOURCE_SUCCESS,
  payload: data,
});

export const saveResourceFailure = (error) => ({
  type: actionTypes.SAVE_RESOURCE_FAILURE,
  payload: error,
});

// ✅ Update Resource
export const updateResourceRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_RESOURCE_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateResourceSuccess = (data) => ({
  type: actionTypes.UPDATE_RESOURCE_SUCCESS,
  payload: data,
});

export const updateResourceFailure = (error) => ({
  type: actionTypes.UPDATE_RESOURCE_FAILURE,
  payload: error,
});

// ✅ Delete Resource
export const deleteResourceRequest = (payload, callback) => ({
  type: actionTypes.DELETE_RESOURCE_REQUEST,
  payload,
  callback,
});

export const deleteResourceSuccess = (data) => ({
  type: actionTypes.DELETE_RESOURCE_SUCCESS,
  payload: data,
});

export const deleteResourceFailure = (error) => ({
  type: actionTypes.DELETE_RESOURCE_FAILURE,
  payload: error,
});
